import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Area } from '../../../DataStructures/Area/Area';
import * as moment from 'moment';

@Component({
  selector: 'app-week-search-result-dialog',
  templateUrl: './week-search-result-dialog.component.html',
  styleUrls: ['./week-search-result-dialog.component.css']
})
export class WeekSearchResultDialogComponent implements OnInit {

  areas:Array<Area>

  constructor(public dialogRef: MatDialogRef<WeekSearchResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WeekSearchResults) {

      this.areas = data.areas;

    }

  ngOnInit(){

  }

  formatDate(area:Area){
     return moment(area.slotTime).format("dddd hh:mm A");
  }

}

export interface WeekSearchResults{
  areas:Array<Area>
}



// WEBPACK FOOTER //
// ./src/app/admin-dashboard/optimizer/week-search-result-dialog/week-search-result-dialog.component.ts